// Stub — real auth (core-api session token flow) is future scope
import { createContext, useContext, type ReactNode } from 'react';

export interface AuthContext {
  isAuthenticated: boolean;
  isLoading: boolean;
}

const DEFAULT_AUTH: AuthContext = { isAuthenticated: false, isLoading: false };

const AuthCtx = createContext<AuthContext>(DEFAULT_AUTH);

export const AuthProvider = ({ children }: { children: ReactNode }) => (
  <AuthCtx.Provider value={DEFAULT_AUTH}>{children}</AuthCtx.Provider>
);

export const useAuth = () => useContext(AuthCtx);
